export const COLORES_RAMA = [
    'var(--bs-primary)',
    'var(--bs-success)',
    'var(--bs-info)',
    'var(--bs-warning)',
    'var(--bs-danger)'
]

export const ESCALA_MINIMA = 0.4
export const ESCALA_MAXIMA = 1.5
export const PASO_ESCALA = 0.1

export const RUTA_IMPRESION_ORGANIGRAMA = 'imprimir/organigrama'
